import fetch from '@/axios/promise';
import  {BUDGET_URL} from  '@/config/constant';

// 获取列表数据
export function page(query) {
  return invoke(query,'/getProjBudgetPage','POST');
}

// 获取项目预算数据
export function getProjBudgetData(query) {
  return invoke(query,'/getProjBudgetData','POST');
}

// 获取人员维护的数据
export function getProjBudgetPersonData(query){
  return invoke(query,'/getProjBudgetPersonData','POST');
}

// 获取项目预算审批数据
export function getProjBudgetDataApproval(query){
  return invoke(query,'/getProjBudgetDataApproval','POST');
}

// 项目预算流程提交
export function apprProcSubmit(query) {
  return invoke(query,'/apprProcSubmit','POST');
}

// 项目预算的审批处理
export function approveBudget(query) {
  return invoke(query,'/approveBudget','POST');
}

// 获取项目预算的阶段层级数据
export function getProjStagePlanLvlList(query) {
  return invoke(query,'/getProjStagePlanLvlList','POST');
}

// 根据项目及人员信息获取预算人员计划
export function getProjPersonPlanDataByConditon(query) {
  return invoke(query,'/getProjPersonPlanDataByConditon','POST');
}

// 调用
function invoke(query,url,method){
  return fetch({
    url: BUDGET_URL+url,
    method: method,
    params: query
  });
}


// WEBPACK FOOTER //
// ./src/api/pm/budget.js